// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BasicMap__wrapper__3viJb","tooltip":"BasicMap__tooltip__2gEmN","bold":"BasicMap__bold__sUbXS"};